import apiConfig from "@/configs/apiConfig";
import { CartItem } from "@/types";

// Save cart with expiry timestamp
export const saveCartToStorage = (cartItems: CartItem[]) => {
  localStorage.setItem(apiConfig.CART_STORAGE_KEY, JSON.stringify(cartItems));

  const expiresAt = Date.now() + apiConfig.CART_EXPIRY_HOURS * 60 * 60 * 1000;
  localStorage.setItem(apiConfig.CART_EXPIRY_KEY, expiresAt.toString());
  const storedExpiry = localStorage.getItem(apiConfig.CART_EXPIRY_KEY);
  const storedItems = localStorage.getItem(apiConfig.CART_STORAGE_KEY);
  console.log("----key1", apiConfig.CART_STORAGE_KEY);
  console.log("----key2", apiConfig.CART_EXPIRY_KEY);

  console.log("save key found", storedExpiry);
  console.log("save item found", storedItems);
};

// Load + check expiry
export const loadCartFromStorage = (): CartItem[] => {
  const storedExpiry = localStorage.getItem(apiConfig.CART_EXPIRY_KEY);
  const storedItems = localStorage.getItem(apiConfig.CART_STORAGE_KEY);
  console.log("Cache key found", storedExpiry);
  console.log("Cache item found", storedItems);
  if (!storedExpiry || !storedItems) return [];

  const now = Date.now();
  const expiry = parseInt(storedExpiry);
  console.log("Current", now);
  console.log("Expiry", expiry);

  // ❌ Expired → clear and return empty cart
  if (now > expiry) {
    console.log("Expired");

    localStorage.removeItem(apiConfig.CART_STORAGE_KEY);
    localStorage.removeItem(apiConfig.CART_EXPIRY_KEY);
    return [];
  }

  // ✔ valid cart
  return JSON.parse(storedItems);
};
